/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Before_3Inputs */

const en_landing_before_3 = /** @type {(inputs: Landing_Before_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hours spent rewriting for each application`)
};

const de_landing_before_3 = /** @type {(inputs: Landing_Before_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stunden mit Umschreiben fuer jede Bewerbung`)
};

const fr_landing_before_3 = /** @type {(inputs: Landing_Before_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des heures passées à réécrire pour chaque candidature`)
};

const es_landing_before_3 = /** @type {(inputs: Landing_Before_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horas reescribiendo para cada solicitud`)
};

const it_landing_before_3 = /** @type {(inputs: Landing_Before_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ore perse a riscrivere per ogni candidatura`)
};

const nl_landing_before_3 = /** @type {(inputs: Landing_Before_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uren besteed aan herschrijven voor elke sollicitatie`)
};

const pl_landing_before_3 = /** @type {(inputs: Landing_Before_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godziny spędzone na przepisywaniu każdej aplikacji`)
};

const fi_landing_before_3 = /** @type {(inputs: Landing_Before_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tunteja uudelleenkirjoittamista jokaiseen hakemukseen`)
};

const da_landing_before_3 = /** @type {(inputs: Landing_Before_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer brugt på omskrivning til hver ansøgning`)
};

const sv_landing_before_3 = /** @type {(inputs: Landing_Before_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timmar med omskrivning för varje ansökan`)
};

/**
* | output |
* | --- |
* | "Hours spent rewriting for each application" |
*
* @param {Landing_Before_3Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_before_3 = /** @type {((inputs?: Landing_Before_3Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Before_3Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_before_3(inputs)
	if (locale === "fr") return fr_landing_before_3(inputs)
	if (locale === "es") return es_landing_before_3(inputs)
	if (locale === "it") return it_landing_before_3(inputs)
	if (locale === "nl") return nl_landing_before_3(inputs)
	if (locale === "pl") return pl_landing_before_3(inputs)
	if (locale === "fi") return fi_landing_before_3(inputs)
	if (locale === "da") return da_landing_before_3(inputs)
	if (locale === "sv") return sv_landing_before_3(inputs)
	return en_landing_before_3(inputs)
});